import CityPageTemplate from "../city-template/CityPageTemplate";
import { durhamConfig } from "./data";

export default function DurhamPage() {
  return <CityPageTemplate config={durhamConfig} />;
}